import { ContactLink, FooterLink, HeaderLink, Project } from "@/global";

export const contactLinks: ContactLink[] = [
  {
    id: 1,
    title: "linkedin",
    url: "https://www.linkedin.com/in/mehdifaraji",
    username: "@mehdifaraji",
    icon: () => (
      <svg width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="#ffffff"
          d="M14.5455 0H1.45455C0.650909 0 0 0.650909 0 1.45455V14.5455C0 15.3491 0.650909 16 1.45455 16H14.5455C15.3491 16 16 15.3491 16 14.5455V1.45455C16 0.650909 15.3491 0 14.5455 0ZM5.05746 13.0909H2.912V6.18764H5.05746V13.0909ZM3.96291 5.20073C3.27127 5.20073 2.712 4.64 2.712 3.94982C2.712 3.25964 3.272 2.69964 3.96291 2.69964C4.65236 2.69964 5.21309 3.26036 5.21309 3.94982C5.21309 4.64 4.65236 5.20073 3.96291 5.20073ZM13.0938 13.0909H10.9498V9.73382C10.9498 8.93309 10.9353 7.90327 9.83491 7.90327C8.71855 7.90327 8.54691 8.77527 8.54691 9.67564V13.0909H6.40291V6.18764H8.46109V7.13091H8.49018C8.77673 6.58836 9.47636 6.016 10.52 6.016C12.6924 6.016 13.0938 7.44582 13.0938 9.30473V13.0909V13.0909Z"
        />
      </svg>
    ),
  },
  {
    id: 4,
    title: "whatsapp",
    url: "https://wa.me/+989371101609",
    username: "+989371101609",
    icon: () => (
      <svg className="w-4 h-4" fill="#fff" viewBox="0 0 308 308">
        <g>
          <path
            d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"
          />
          <path
            d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: 2,
    title: "gmail",
    url: "mailto:mahdifarajideveloper@gmail.com",
    username: "mahdifarajideveloper@gmail",
    icon: () => (
      <svg fill="#fff" className="w-4 h-4" viewBox="0 0 75 75">
        <g>
          <path
            d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
		c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
		H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
		c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
		c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
		c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
		c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: 3,
    title: "telegram",
    url: "https://t.me/mcodes1",
    username: "@mcodes1",
    icon: () => (
      <svg className="w-4 h-4" viewBox="0 0 240 240">
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="120"
            y1="240"
            x2="120"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" />
            <stop offset="1" stopColor="#fff" />
          </linearGradient>
        </defs>
        <circle cx="120" cy="120" r="120" fill="url(#linear-gradient)" />
        <path
          d="M81.229,128.772l14.237,39.406s1.78,3.687,3.686,3.687,30.255-29.492,30.255-29.492l31.525-60.89L81.737,118.6Z"
          fill="#fff"
        />
        <path
          d="M100.106,138.878l-2.733,29.046s-1.144,8.9,7.754,0,17.415-15.763,17.415-15.763"
          fill="#000000"
        />
        <path
          d="M81.486,130.178,52.2,120.636s-3.5-1.42-2.373-4.64c.232-.664.7-1.229,2.1-2.2,6.489-4.523,120.106-45.36,120.106-45.36s3.208-1.081,5.1-.362a2.766,2.766,0,0,1,1.885,2.055,9.357,9.357,0,0,1,.254,2.585c-.009.752-.1,1.449-.169,2.542-.692,11.165-21.4,94.493-21.4,94.493s-1.239,4.876-5.678,5.043A8.13,8.13,0,0,1,146.1,172.5c-8.711-7.493-38.819-27.727-45.472-32.177a1.27,1.27,0,0,1-.546-.9c-.093-.469.417-1.05.417-1.05s52.426-46.6,53.821-51.492c.108-.379-.3-.566-.848-.4-3.482,1.281-63.844,39.4-70.506,43.607A3.21,3.21,0,0,1,81.486,130.178Z"
          fill="#000000"
        />
      </svg>
    ),
  },
];

export const footerSocialLinks: FooterLink[] = [
  {
    id: 1,
    title: "linkedin",
    url: "https://www.linkedin.com/in/mehdifaraji",
    icon: () => (
      <svg width="16" height="16" viewBox="0 0 16 16">
        <path
          fill="#ffffff"
          d="M14.5455 0H1.45455C0.650909 0 0 0.650909 0 1.45455V14.5455C0 15.3491 0.650909 16 1.45455 16H14.5455C15.3491 16 16 15.3491 16 14.5455V1.45455C16 0.650909 15.3491 0 14.5455 0ZM5.05746 13.0909H2.912V6.18764H5.05746V13.0909ZM3.96291 5.20073C3.27127 5.20073 2.712 4.64 2.712 3.94982C2.712 3.25964 3.272 2.69964 3.96291 2.69964C4.65236 2.69964 5.21309 3.26036 5.21309 3.94982C5.21309 4.64 4.65236 5.20073 3.96291 5.20073ZM13.0938 13.0909H10.9498V9.73382C10.9498 8.93309 10.9353 7.90327 9.83491 7.90327C8.71855 7.90327 8.54691 8.77527 8.54691 9.67564V13.0909H6.40291V6.18764H8.46109V7.13091H8.49018C8.77673 6.58836 9.47636 6.016 10.52 6.016C12.6924 6.016 13.0938 7.44582 13.0938 9.30473V13.0909V13.0909Z"
        />
      </svg>
    ),
  },
  {
    id: 2,
    title: "gmail",
    url: "mailto:mahdifarajideveloper@gmail.com",
    icon: () => (
      <svg fill="#fff" className="w-4 h-4" viewBox="0 0 75 75">
        <g>
          <path
            d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
		c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
		H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
		c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
		c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
		c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
		c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"
          />
        </g>
      </svg>
    ),
  },
  {
    id: 3,
    title: "telegram",
    url: "https://t.me/mehdicodes",
    icon: () => (
      <svg className="w-4 h-4" viewBox="0 0 240 240">
        <defs>
          <linearGradient
            id="linear-gradient"
            x1="120"
            y1="240"
            x2="120"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" />
            <stop offset="1" stopColor="#fff" />
          </linearGradient>
        </defs>
        <circle cx="120" cy="120" r="120" fill="url(#linear-gradient)" />
        <path
          d="M81.229,128.772l14.237,39.406s1.78,3.687,3.686,3.687,30.255-29.492,30.255-29.492l31.525-60.89L81.737,118.6Z"
          fill="#fff"
        />
        <path
          d="M100.106,138.878l-2.733,29.046s-1.144,8.9,7.754,0,17.415-15.763,17.415-15.763"
          fill="#000000"
        />
        <path
          d="M81.486,130.178,52.2,120.636s-3.5-1.42-2.373-4.64c.232-.664.7-1.229,2.1-2.2,6.489-4.523,120.106-45.36,120.106-45.36s3.208-1.081,5.1-.362a2.766,2.766,0,0,1,1.885,2.055,9.357,9.357,0,0,1,.254,2.585c-.009.752-.1,1.449-.169,2.542-.692,11.165-21.4,94.493-21.4,94.493s-1.239,4.876-5.678,5.043A8.13,8.13,0,0,1,146.1,172.5c-8.711-7.493-38.819-27.727-45.472-32.177a1.27,1.27,0,0,1-.546-.9c-.093-.469.417-1.05.417-1.05s52.426-46.6,53.821-51.492c.108-.379-.3-.566-.848-.4-3.482,1.281-63.844,39.4-70.506,43.607A3.21,3.21,0,0,1,81.486,130.178Z"
          fill="#000000"
        />
      </svg>
    ),
  },
  {
    id: 4,
    title: "whatsapp",
    url: "https://wa.me/+989371101609",
    icon: () => (
      <svg className="w-4 h-4" fill="#fff" viewBox="0 0 308 308">
        <g>
          <path
            d="M227.904,176.981c-0.6-0.288-23.054-11.345-27.044-12.781c-1.629-0.585-3.374-1.156-5.23-1.156
		c-3.032,0-5.579,1.511-7.563,4.479c-2.243,3.334-9.033,11.271-11.131,13.642c-0.274,0.313-0.648,0.687-0.872,0.687
		c-0.201,0-3.676-1.431-4.728-1.888c-24.087-10.463-42.37-35.624-44.877-39.867c-0.358-0.61-0.373-0.887-0.376-0.887
		c0.088-0.323,0.898-1.135,1.316-1.554c1.223-1.21,2.548-2.805,3.83-4.348c0.607-0.731,1.215-1.463,1.812-2.153
		c1.86-2.164,2.688-3.844,3.648-5.79l0.503-1.011c2.344-4.657,0.342-8.587-0.305-9.856c-0.531-1.062-10.012-23.944-11.02-26.348
		c-2.424-5.801-5.627-8.502-10.078-8.502c-0.413,0,0,0-1.732,0.073c-2.109,0.089-13.594,1.601-18.672,4.802
		c-5.385,3.395-14.495,14.217-14.495,33.249c0,17.129,10.87,33.302,15.537,39.453c0.116,0.155,0.329,0.47,0.638,0.922
		c17.873,26.102,40.154,45.446,62.741,54.469c21.745,8.686,32.042,9.69,37.896,9.69c0.001,0,0.001,0,0.001,0
		c2.46,0,4.429-0.193,6.166-0.364l1.102-0.105c7.512-0.666,24.02-9.22,27.775-19.655c2.958-8.219,3.738-17.199,1.77-20.458
		C233.168,179.508,230.845,178.393,227.904,176.981z"
          />
          <path
            d="M156.734,0C73.318,0,5.454,67.354,5.454,150.143c0,26.777,7.166,52.988,20.741,75.928L0.212,302.716
		c-0.484,1.429-0.124,3.009,0.933,4.085C1.908,307.58,2.943,308,4,308c0.405,0,0.813-0.061,1.211-0.188l79.92-25.396
		c21.87,11.685,46.588,17.853,71.604,17.853C240.143,300.27,308,232.923,308,150.143C308,67.354,240.143,0,156.734,0z
		 M156.734,268.994c-23.539,0-46.338-6.797-65.936-19.657c-0.659-0.433-1.424-0.655-2.194-0.655c-0.407,0-0.815,0.062-1.212,0.188
		l-40.035,12.726l12.924-38.129c0.418-1.234,0.209-2.595-0.561-3.647c-14.924-20.392-22.813-44.485-22.813-69.677
		c0-65.543,53.754-118.867,119.826-118.867c66.064,0,119.812,53.324,119.812,118.867
		C276.546,215.678,222.799,268.994,156.734,268.994z"
          />
        </g>
      </svg>
    ),
  },
];

export const footerLinks: Omit<FooterLink, "icon">[] = [
  {
    id: 1,
    title: "github",
    url: "https://github.com/1mehdifaraji",
  },
  {
    id: 2,
    title: "stackoverflow",
    url: "https://stackoverflow.com/users/13628101/mehdi-faraji",
  },
  {
    id: 3,
    title: "bluesky",
    url: "https://bsky.app/profile/mehdifaraji.bsky.social",
  },
  {
    id: 4,
    title: "leetcode",
    url: "https://leetcode.com/u/mehdifaraji",
  },
  {
    id: 5,
    title: "npm",
    url: "https://www.npmjs.com/~mehdifaraji",
  },
  {
    id: 6,
    title: "medium",
    url: "https://medium.com/@mehdifaraji",
  },
  {
    id: 7,
    title: "dev.to",
    url: "https://dev.to/mehdifaraji",
  },
  {
    id: 8,
    title: "virgool",
    url: "https://virgool.io/@mehdifaraji",
  },
  {
    id: 9,
    title: "X",
    url: "https://x.com/1mehdifaraji",
  },
];

export const companies = [
  {
    id: 1,
    title: "exir",
    img: "exir.png",
  },
  {
    id: 7,
    title: "huawei",
    img: "huawei.svg",
  },

  {
    id: 3,
    title: "eghtesadonline",
    img: "eghtesadonline.svg",
  },
  {
    id: 9,
    title: "jibifood",
    img: "jibifood.svg",
  },
  {
    id: 4,
    title: "persol",
    img: "persol.svg",
  },
  {
    id: 2,
    title: "mirorim",
    img: "mirorim.svg",
  },
  {
    id: 8,
    title: "fanap",
    img: "fanap.svg",
  },
  {
    id: 10,
    title: "mci",
    img: "mci.svg",
  },

  {
    id: 11,
    title: "safaro",
    img: "safaro.png",
  },
  {
    id: 12,
    title: "shetab",
    img: "shetab.png",
  },
];

export const headerLinks: HeaderLink[] = [
  {
    id: 1,
    title: "about",
    url: "#about",
  },
  // {
  //   id: 2,
  //   title: "projects",
  //   url: "#projects",
  // },
];

export const projects: Project[] = [
  {
    id: 1,
    title: "hooman",
    img: "hooman",
    subtitle:
      "connecting brands and humans through thoughtful digital experiences.",
    url: "https://hooman.com/",
    tech: ["react native", "nextjs"],
  },
  {
    id: 2,
    title: "exir",
    img: "exir",
    subtitle: "the first and most reliable digital currency exchange.",
    url: "https://www.exir.io/",
    tech: ["react native", "reactjs"],
  },
  {
    id: 3,
    title: "mirorim",
    img: "mirorim",
    subtitle: "AI-Powered project management platform.",
    url: "https://mirorim.com/",
    tech: ["vuejs", "react native"],
  },
  {
    id: 4,
    title: "ali motamed",
    img: "alimotamed",
    subtitle: "photography and videography marketing agency.",
    url: "https://alimotamed.com/",
    tech: ["nextjs"],
  },
  {
    id: 5,
    title: "bazorg",
    img: "persol",
    subtitle:
      "wide range of goods and high quality raw materials ecommerce platform.",
    url: "https://bazorg.com/",
    tech: ["nextjs", "react native"],
  },
  {
    id: 6,
    title: "safaro iranian",
    img: "safaro",
    subtitle: "domestic and foreign travel tours agency.",
    url: "https://www.safaroiranian.ir/",
    tech: ["nextjs"],
  },
  {
    id: 7,
    title: "servatino",
    img: "servatino",
    subtitle:
      "the first comprehensive financial and investment management application.",
    url: "https://servatino.com/",
    tech: ["nextjs", "react native"],
  },
  {
    id: 8,
    title: "joboffer",
    img: "joboffer",
    subtitle:
      "job searching platform with the largest number of job advertisements.",
    url: "https://joboffer.ir/",
    tech: ["reactjs", "graphql"],
  },
  {
    id: 9,
    title: "testpro",
    img: "testpro",
    subtitle:
      "specialized tests platform measuring skills and evaluation of job seekers.",
    url: "https://www.testpro.ir/",
    tech: ["reactjs", "graphql"],
  },
  {
    id: 10,
    title: "cvpro",
    img: "cvpro",
    subtitle:
      "online resume builder to increase the employment rate of job seekers.",
    url: "https://cvpro.ir/",
    tech: ["reactjs", "graphql"],
  },
  {
    id: 11,
    title: "kareto",
    img: "kareto",
    subtitle: "specialized small businesses training platform.",
    url: "https://kareto.app/",
    tech: ["reactjs"],
  },
  {
    id: 12,
    title: "brandy2",
    img: "brandy",
    subtitle: "clothes ecommerce platform.",
    url: "https://www.brandyto.com/",
    tech: ["nextjs"],
  },
  {
    id: 13,
    title: "jibifood",
    img: "jb",
    subtitle: "online food ordering application.",
    url: "https://gbfood.ir/",
    tech: ["react native", "reactjs"],
  },
  {
    id: 14,
    title: "teamsho",
    img: "teamsho",
    subtitle: "insurance purchasing platform.",
    url: "https://teamshoo.com/",
    tech: ["nextjs"],
  },
  {
    id: 15,
    title: "rythmitica",
    img: "rythmitica",
    subtitle: "online music academy.",
    url: "https://rhythmitica.com/",
    tech: ["reactjs", "gatsby js"],
  },
  {
    id: 16,
    title: "mendel",
    img: "mendel",
    subtitle: "genetics laboratory website.",
    url: "https://mendel.ir/",
    tech: ["nextjs"],
  },
  {
    id: 17,
    title: "faragene",
    img: "faragene",
    subtitle: "specialized health reference platform.",
    url: "https://faragene.com/",
    tech: ["nextjs"],
  },
  {
    id: 18,
    title: "bazarkade",
    img: "bazarkade",
    subtitle: "online store for all tastes.",
    url: "https://cafebazaar.ir/app/com.tivasoft.bazarkadeh",
    tech: ["react native"],
  },
  {
    id: 19,
    title: "etraab",
    img: "etraab",
    subtitle: "the first cloud communication center solution.",
    url: "https://rokhcc.ir/",
    tech: ["reactjs"],
  },
];

export const services = [
  "project management",
  "development",
  "prototyping & design",
  "consulting",
];
